import React from 'react';

const PageProvider = React.createContext<[any, any]>([{}, {}]);

export default PageProvider;